import HtmlHelper from '../../../general/js/html-helper';
import TweenLite from 'gsap/TweenLite';
import app from '../../../general/js/app';
import BaseComponent from '../../../general/js/base-component';

export default class NavItem extends BaseComponent {
    constructor() {
        super(...arguments);

        this.trigger = this.refs.trigger;
        this.submenu = this.refs.submenu;

        this.onToggle = this.props.onToggle;
        this.triggers = this.props.triggers;

        this.outerTrigger = null;
        let id = this.element.dataset.id;
        if (id && this.triggers[id]) {
            this.outerTrigger = this.triggers[id];
        }

        this.hasBeenOpened = false;
        this.isOpened = false;
        //that flag shows that item has been opened by clicking on
        //desktop menu items rather than hamburger items
        this.fromOuter = true;
        this.init();
    }

    static getRequiredRefs() {
        return ['trigger', 'submenu'];
    }

    static getRequiredProps() {
        return ['onToggle', 'triggers'];
    }

    init() {
        this.trigger.addEventListener('click', this.toggle.bind(this));
        HtmlHelper.safeAddEventListener(this.outerTrigger, 'mouseenter', this.outerDesktopTriggerToggle.bind(this));
        HtmlHelper.safeAddEventListener(this.submenu, 'mouseleave', this.outerDesktopTriggerToggle.bind(this));
    }

    outerTriggerToggle(e) {
        e.preventDefault();
        this.fromOuter = true;
        this.toggle(e);
    }

    outerDesktopTriggerToggle(e) {
        e.preventDefault();
        if (app.isDesktop) {
            this.fromOuter = true;
            this.toggle(e);
        }
    }

    toggle(e) {
        e.preventDefault();
        //difference between these options is
        //nav items on mobile can open in independently
        //but on desktop we have to close previously opened nav item
        if (app.isDesktop) {
            //so pass instance of new item through NavComponent::onToggle callback
            //and it will do logic for us
            this.onToggle(this);
        } else {
            //otherwise just open or close depending on the inner state
            if (!this.isOpened) {
                this.open();
            } else {
                this.close();
            }
        }
    }

    open() {
        if (!this.hasBeenOpened) {
            this.hasBeenOpened = true;
            this.tween = TweenLite.fromTo(this.submenu, 0.3, {
                height: 0,
                opacity: 0
            }, {
                height: app.isDesktop ? 75 : 'auto',
                opacity: 1,
                onReverseComplete: () => {
                    this.handleClose();
                }
            });
        }

        if (!this.isOpened) {
            this.isOpened = true;
            this.element.classList.add('is-opened');
            //if current opening is caused by desktop navigation link
            //we have to highlight it too
            if (this.fromOuter) {
                this.outerTrigger.classList.add('is-opened');
            }
            this.tween.play();
        }
    }

    close() {
        return new Promise((resolve) => {
            this.finishClose = resolve;
            this.tween.reverse();
        });
    }

    handleClose() {
        this.element.classList.remove('is-opened');
        if (this.fromOuter) {
            this.outerTrigger.classList.remove('is-opened');
        }

        //resolve promise of current item closing
        if (this.finishClose) {
            this.finishClose();
        }

        this.isOpened = false;
        this.fromOuter = false;
    }

    reset() {
        //recreate tween to reset cached heights of items
        this.hasBeenOpened = false;
        if (this.isOpened) {
            this.handleClose();
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/header/js/nav-item.component.js